<template>
  <div>
    <platform-nav v-if="loggedIn" class="no-print" />
    <platform-header class="no-print" />
    <v-main>
      <router-view v-slot="{ Component }">
        <v-fade-transition mode="out-in">
          <component :is="Component" />
        </v-fade-transition>
      </router-view>
    </v-main>
    <platform-footer />
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useAppStateStore } from "@/stores/AppStateStore";
import { userTierMixin } from "@/mixins/UserTier";
import PlatformHeader from "@/layouts/Header.vue";
import PlatformNav from "@/layouts/Nav.vue";
import PlatformFooter from "@/layouts/Footer.vue";

export default {
  name: "PlatformLayout",
  components: {
    PlatformHeader,
    PlatformNav,
    PlatformFooter,
  },
  mixins: [userTierMixin],
  computed: {
    ...mapStores(useAppStateStore),
  },
};
</script>
